import { default as _91id_93mWlO4A1LvgMeta } from "/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/accounts/[id].vue?macro=true";
import { default as accountsrxDlzhwvCqMeta } from "/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/accounts.vue?macro=true";
import { default as analyticsryHNhzxsbFMeta } from "/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/analytics.vue?macro=true";
import { default as contactsQAmXxTzV6CMeta } from "/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/contacts.vue?macro=true";
import { default as mailboxesWJ81FAHvgcMeta } from "/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/mailboxes.vue?macro=true";
import { default as newDrMel3O40WMeta } from "/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/new.vue?macro=true";
import { default as schedulePqY6zrOlozMeta } from "/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/schedule.vue?macro=true";
import { default as stepsI17NgqDj7vMeta } from "/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/steps.vue?macro=true";
import { default as outreachyUe4OFA2JSMeta } from "/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach.vue?macro=true";
import { default as setupthUXxvEBUoMeta } from "/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/setup.vue?macro=true";
import { default as _91icp_93j5hqj2T52YMeta } from "/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp].vue?macro=true";
import { default as indexXgHP7mqv8ZMeta } from "/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/index.vue?macro=true";
import { default as campaigns7pj1Zvr8IqMeta } from "/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns.vue?macro=true";
import { default as discoverUKqa7ptzOPMeta } from "/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/discover.vue?macro=true";
import { default as indexw5KZ2wsnOjMeta } from "/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/index.vue?macro=true";
import { default as opensD9EQZZF1psMeta } from "/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/opens.vue?macro=true";
import { default as repliesxyBduEm1ssMeta } from "/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/replies.vue?macro=true";
import { default as _91listId_934eRIvTGatnMeta } from "/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/saved/[listId].vue?macro=true";
import { default as allrPnuEFv88hMeta } from "/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/saved/all.vue?macro=true";
import { default as mineSm9V16AqdzMeta } from "/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/saved/mine.vue?macro=true";
import { default as sequencesjbFkwFZajeMeta } from "/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/sequences.vue?macro=true";
import { default as accountVXzr4pZmVeMeta } from "/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/account.vue?macro=true";
import { default as crmoNy6DA2sPeMeta } from "/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/crm.vue?macro=true";
import { default as engaged_45accountsrMuLtbtVDEMeta } from "/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/engaged-accounts.vue?macro=true";
import { default as engaged_45contactsCpJVvfj20LMeta } from "/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/engaged-contacts.vue?macro=true";
import { default as exportsBTUY2mU94yMeta } from "/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/exports.vue?macro=true";
import { default as forbidden_45accounts6iWdvaZpJiMeta } from "/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/forbidden-accounts.vue?macro=true";
import { default as forbidden_45contactsWMi9k1hNLGMeta } from "/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/forbidden-contacts.vue?macro=true";
import { default as importsu981JiUI3lMeta } from "/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/imports.vue?macro=true";
import { default as indexe6tL5WFBqNMeta } from "/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/index.vue?macro=true";
import { default as integrationsZgXOb2VU3IMeta } from "/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/integrations.vue?macro=true";
import { default as mailbox0TVXyzFwkgMeta } from "/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/mailbox.vue?macro=true";
import { default as notificationsA5HOadA0AuMeta } from "/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/notifications.vue?macro=true";
import { default as organizationrof5jRtkXhMeta } from "/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/organization.vue?macro=true";
import { default as repliesmWOLWc78XFMeta } from "/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/replies.vue?macro=true";
import { default as settingsmv4XiWS8vyMeta } from "/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings.vue?macro=true";
import { default as advanced_45icpVCSckj4UWtMeta } from "/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/advanced-icp.vue?macro=true";
import { default as advancedd99CFAjt08Meta } from "/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/advanced.vue?macro=true";
import { default as employees2ZLRunz4SbMeta } from "/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/employees.vue?macro=true";
import { default as job_45openingsmuiJ8UD4N4Meta } from "/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/job-openings.vue?macro=true";
import { default as news53RO31XgRNMeta } from "/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/news.vue?macro=true";
import { default as websites9EK5mQSUUKMeta } from "/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/websites.vue?macro=true";
import { default as signinDiCGcraLTpMeta } from "/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signin.vue?macro=true";
import { default as signupK2xBqnRnFoMeta } from "/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signup.vue?macro=true";
export default [
  {
    name: "accounts-id",
    path: "/accounts/:id()",
    component: () => import("/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/accounts/[id].vue")
  },
  {
    name: campaigns7pj1Zvr8IqMeta?.name,
    path: "/campaigns",
    component: () => import("/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns.vue"),
    children: [
  {
    name: "campaigns-icp",
    path: ":icp()",
    component: () => import("/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp].vue"),
    children: [
  {
    name: "campaigns-icp-accounts",
    path: "accounts",
    component: () => import("/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/accounts.vue")
  },
  {
    name: "campaigns-icp-analytics",
    path: "analytics",
    component: () => import("/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/analytics.vue")
  },
  {
    name: "campaigns-icp-outreach",
    path: "outreach",
    component: () => import("/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach.vue"),
    children: [
  {
    name: "campaigns-icp-outreach-contacts",
    path: "contacts",
    component: () => import("/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/contacts.vue")
  },
  {
    name: "campaigns-icp-outreach-mailboxes",
    path: "mailboxes",
    component: () => import("/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/mailboxes.vue")
  },
  {
    name: "campaigns-icp-outreach-new",
    path: "new",
    component: () => import("/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/new.vue")
  },
  {
    name: "campaigns-icp-outreach-schedule",
    path: "schedule",
    component: () => import("/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/schedule.vue")
  },
  {
    name: "campaigns-icp-outreach-steps",
    path: "steps",
    component: () => import("/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/steps.vue")
  }
]
  },
  {
    name: "campaigns-icp-setup",
    path: "setup",
    component: () => import("/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/setup.vue")
  }
]
  },
  {
    name: "campaigns",
    path: "",
    component: () => import("/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/index.vue")
  }
]
  },
  {
    name: "discover",
    path: "/discover",
    component: () => import("/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/discover.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/index.vue")
  },
  {
    name: "opens",
    path: "/opens",
    component: () => import("/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/opens.vue")
  },
  {
    name: "replies",
    path: "/replies",
    component: () => import("/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/replies.vue")
  },
  {
    name: "saved-listId",
    path: "/saved/:listId()",
    component: () => import("/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/saved/[listId].vue")
  },
  {
    name: "saved-all",
    path: "/saved/all",
    component: () => import("/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/saved/all.vue")
  },
  {
    name: "saved-mine",
    path: "/saved/mine",
    component: () => import("/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/saved/mine.vue")
  },
  {
    name: "sequences",
    path: "/sequences",
    component: () => import("/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/sequences.vue")
  },
  {
    name: settingsmv4XiWS8vyMeta?.name,
    path: "/settings",
    component: () => import("/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings.vue"),
    children: [
  {
    name: "settings-account",
    path: "account",
    component: () => import("/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/account.vue")
  },
  {
    name: "settings-crm",
    path: "crm",
    component: () => import("/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/crm.vue")
  },
  {
    name: "settings-engaged-accounts",
    path: "engaged-accounts",
    component: () => import("/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/engaged-accounts.vue")
  },
  {
    name: "settings-engaged-contacts",
    path: "engaged-contacts",
    component: () => import("/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/engaged-contacts.vue")
  },
  {
    name: "settings-exports",
    path: "exports",
    component: () => import("/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/exports.vue")
  },
  {
    name: "settings-forbidden-accounts",
    path: "forbidden-accounts",
    component: () => import("/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/forbidden-accounts.vue")
  },
  {
    name: "settings-forbidden-contacts",
    path: "forbidden-contacts",
    component: () => import("/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/forbidden-contacts.vue")
  },
  {
    name: "settings-imports",
    path: "imports",
    component: () => import("/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/imports.vue")
  },
  {
    name: "settings",
    path: "",
    component: () => import("/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/index.vue")
  },
  {
    name: "settings-integrations",
    path: "integrations",
    component: () => import("/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/integrations.vue")
  },
  {
    name: "settings-mailbox",
    path: "mailbox",
    component: () => import("/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/mailbox.vue")
  },
  {
    name: "settings-notifications",
    path: "notifications",
    component: () => import("/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/notifications.vue")
  },
  {
    name: "settings-organization",
    path: "organization",
    component: () => import("/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/organization.vue")
  },
  {
    name: "settings-replies",
    path: "replies",
    component: () => import("/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/replies.vue")
  }
]
  },
  {
    name: "signals-advanced-icp",
    path: "/signals/advanced-icp",
    component: () => import("/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/advanced-icp.vue")
  },
  {
    name: "signals-advanced",
    path: "/signals/advanced",
    component: () => import("/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/advanced.vue")
  },
  {
    name: "signals-employees",
    path: "/signals/employees",
    component: () => import("/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/employees.vue")
  },
  {
    name: "signals-job-openings",
    path: "/signals/job-openings",
    component: () => import("/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/job-openings.vue")
  },
  {
    name: "signals-news",
    path: "/signals/news",
    component: () => import("/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/news.vue")
  },
  {
    name: "signals-websites",
    path: "/signals/websites",
    component: () => import("/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/websites.vue")
  },
  {
    name: "signin",
    path: "/signin",
    component: () => import("/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signin.vue")
  },
  {
    name: "signup",
    path: "/signup",
    component: () => import("/codebuild/output/src2576979715/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signup.vue")
  }
]